import React from "react";
import { Type } from "lucide-react";

function LetterMobileToolbar({
  onOpenFormatting,
  onOpenRecipients,
  formattingOpen = false,
  readOnly = false,
}) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-30 flex justify-center px-4 pb-4 pt-2 lg:hidden">
      <div className="flex items-center gap-2 rounded-2xl border border-greyLight/50 bg-white/95 px-2 py-2 shadow-[0_2px_16px_rgba(0,0,0,0.08)] backdrop-blur-sm">
        {!readOnly && (
          <button
            type="button"
            // Keep editor selection when opening the format drawer.
            onMouseDown={(e) => e.preventDefault()}
            onClick={onOpenFormatting}
            className={`flex h-10 w-10 items-center justify-center rounded-lg border transition ${
              formattingOpen
                ? "border-primaryText/40 bg-primaryText/10 text-primaryText"
                : "border-greyLight/60 text-secondaryText hover:bg-black/[0.03]"
            }`}
            aria-label="Mise en forme"
            aria-pressed={formattingOpen}
          >
            <Type size={18} strokeWidth={2} />
          </button>
        )}
        <button
          type="button"
          onClick={onOpenRecipients}
          className="rounded-lg bg-primaryDark px-5 py-2.5 font-josefin text-sm font-medium text-white transition hover:bg-primaryText"
        >
          Destinataires
        </button>
      </div>
    </div>
  );
}

export default LetterMobileToolbar;
